import { TicketSaleQuantityInformationInterface, UserTicketDanceRoleTypeEnum } from '../../..';

export class TicketSaleQuantityInformationDto implements TicketSaleQuantityInformationInterface {
  ticketId: string;
  ticketName: string;
  boughtQuantity: number;
  checkedInQuantity: number;
  danceRoleType: UserTicketDanceRoleTypeEnum;
}
